import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-link';
import Helmet from 'react-helmet';

import './styles/index.scss';

const Header = () => (
  <div>
    <div className="top-bar" data-responsive-toggle="main-menu" data-hide-for="medium">
      <div className="top-bar-left">
        <ul className="menu">
          <Link to="/" className="menu-text logo">
            Alec Jandorek
          </Link>
        </ul>
      </div>
      <div className="top-bar-right">
        <ul className="menu">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/portfolio">Portfolio</Link>
          </li>
          <li>
            <Link to="/contact">Contact</Link>
          </li>
        </ul>
      </div>
    </div>
  </div>
);

class TemplateWrapper extends React.Component {
  render() {
    return (
      <div>
        <Helmet
          title="Alec Jandorek"
          meta={[
            { name: 'description', content: 'Sample' },
            { name: 'keywords', content: 'sample, something' }
          ]}
        />

        <Header />
        <div>{this.props.children()}</div>
      </div>
    );
  }
}
TemplateWrapper.propTypes = {
  children: PropTypes.func
};

export default TemplateWrapper;



// WEBPACK FOOTER //
// ./src/layouts/index.js